import React, { useEffect } from 'react';

import { getErrorMessage } from '~libs/axiosWrapper';

import { ErrorResponse, ModalCard, Spinner } from '~components';
import { TableView } from '~components/table-view-v3';

import columns from '~support-at-home/forms/budgets/bulkCopyList';

import { useBulkCopyMutation } from '~support-at-home/actions/budgets';

interface ComponentProps {
  value: { budget_ids: string[]; start_date: string; end_date: string };
}

const Review: React.FC<ComponentProps> = ({ value }) => {
  const { start_date, end_date, budget_ids } = value;
  const [bulkCopy, { data, error, isLoading }] = useBulkCopyMutation();

  useEffect(() => {
    bulkCopy({ start_date, end_date, budget_ids });
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner loading={isLoading} />
        <p className="mt-3 text-muted">Bulk copying budgets...</p>
      </div>
    );
  }

  if (error) return <ErrorResponse message={getErrorMessage(error)} />;
  if (!data) return null;

  return (
    <div>
      <ModalCard header={`${data.length} New Budgets Created`} className="w-100">
        <TableView id="bulk-copy-estimate-table" data={data} columns={columns} readonly striped />
      </ModalCard>
    </div>
  );
};

export default Review;
